import SearchBox from "../CommonComponents/SearchBox";
import { Box, Container, Pagination, Stack, Typography } from "@mui/material";
import Skills from "../Droners/Skills";
import { JobCard } from "../JobCard";
import React, { useContext, useEffect, useState } from "react";
import { LocalizationContext } from "../../lib/context";
import { useUserData } from "../../hooks/useUserData";
import { collection, getDocs, query, where } from "firebase/firestore";
import { db } from "../../../api_config/firebase-configuration";

const JobsSearch = ({ jobs }: { jobs: any }) => {
  const { jobPage, jobsPage } = useContext(LocalizationContext).localeStrings;

  const [sortedJobs, setSortedJobs] = useState(jobs);
  const [filteredJobs, setFilteredJobs] = useState<Array<any>>([]);
  const [activeSkill, setActiveSkill] = useState<string>("all");
  const [jobsCount, setJobsCount] = useState<number>(0);
  const [pagedJobs, setPagedJobs] = useState<Array<any>>([]);
  const { actDroner } = useUserData();
  const [dronerTenders, setDronerTenders] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const offerDeadlineText = jobPage.offerDeadline;
  const [page, setPage] = useState(1);
  const [filters, setFilters] = useState({
    location: [],
    equipment: [],
    "free-range": 0,
    "max-range": 0,
    certification: [],
  });

  useEffect(() => {
    const sortJobs = (jobs: any) => {
      const skills: any = {};
      skills["all"] = jobs;
      for (const job of jobs) {
        if (job?.skills && job?.skills.length > 0) {
          const skill = job.skills[0];
          if (skill && skills.hasOwnProperty(skill)) {
            skills[skill].push(job);
          } else {
            skills[skill] = [job];
          }
        }
      }
      delete skills.null;
      return skills;
    };
    setSortedJobs(sortJobs(jobs));
  }, [jobs]);

  useEffect(() => {
    const start = (page - 1) * 20;
    const end = page * 20;
    setPagedJobs(filteredJobs.slice(start, end));
  }, [page, filteredJobs]);

  useEffect(() => {
    setPage(1);
  }, [filteredJobs]);

  useEffect(() => {
    const getFilters = () => {
      let locations: string[] = [];
      let skills: string[] = [];
      let equipments: string[] = [];
      for (const filter in filters) {
        if (filter == "location") {
          locations = Object.values(filters[filter]).map((f: any) => f.value);
        } else if (filter == "certification") {
          skills = Object.values(filters[filter]).map((f: any) => f.value);
        } else if (filter == "equipment") {
          equipments = Object.values(filters[filter]).map(
            (f: any) => f.translation
          );
        }
      }
      return {
        locations,
        certificates: skills,
        equipments,
        maxRange: filters["max-range"],
        freeRange: filters["free-range"],
      };
    };
    const { locations, certificates, equipments, maxRange, freeRange } =
      getFilters();

    let completeFilteredJobs = jobs;

    if (activeSkill != "all") {
      completeFilteredJobs = sortedJobs[activeSkill];
    }

    completeFilteredJobs = completeFilteredJobs?.filter((job: any) => {
      if (maxRange) {
        if (!(maxRange >= job.maxRange)) return false;
      }

      if (freeRange) {
        if (!(freeRange >= job.freeDist)) return false;
      }

      if (!locations.length && !certificates.length && !equipments.length)
        return true;

      if (locations.length > 0) {
        if (locations.indexOf(job.country) > -1) {
          return true;
        }
      }

      if (equipments.length > 0) {
        for (const equipment of equipments) {
          const matchEquipment = job.equipment.some(
            (dEquipment: string) => equipment == dEquipment
          );
          if (matchEquipment) return true;
        }
      }
      if (certificates.length > 0) {
        for (const certificate of certificates) {
          const matchCertificate = job.certificate?.some(
            (dCert: string) => certificate == dCert
          );
          if (matchCertificate) return true;
        }
      }

      return false;
    });

    if (searchQuery !== "") {
      completeFilteredJobs = completeFilteredJobs.filter((job: any) =>
        job?.title?.toLowerCase().includes(searchQuery.toLocaleLowerCase())
      );
    }

    const start = (page - 1) * 16;
    const end = page * 16;
    setPagedJobs(completeFilteredJobs?.slice(start, end));
    setJobsCount(completeFilteredJobs?.length);
  }, [sortedJobs, filters, activeSkill, jobs, searchQuery, page]);

  useEffect(() => {
    if (actDroner) {
      const temp: any = [];
      const dronerTenderQuery = query(
        collection(db, "offers"),
        where("uid", "==", actDroner.uid)
      );
      getDocs(dronerTenderQuery)
        .then((snap) => {
          snap.forEach((doc) => {
            temp.push(doc.data());
          });
          setDronerTenders(temp);
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }, [actDroner]);

  const handlePageChange = (
    event: React.ChangeEvent<unknown>,
    value: number
  ) => {
    setPage(value);
  };
  return (
    <>
      <SearchBox
        setFilter={setFilters}
        filter={filters}
        setQuery={setSearchQuery}
      />

      <Container sx={{ overflowX: "scroll" }} id="all-jobs">
        {Object.keys(sortedJobs).length > 0 && (
          <Skills skills={sortedJobs} setActiveSkill={setActiveSkill} />
        )}
      </Container>

      <Container
        className="flex col gap-normal"
        sx={{
          maxWidth: "1248px",
        }}
      >
        <Typography variant="h2" className="pb-small">
          {jobsPage.pageTitle}
        </Typography>
        <Typography className="pb-large">{jobsPage.browseOurJobs}</Typography>

        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fill, minmax(250px, 1fr))",
            justifyContent: "space-between",
            gap: 2,
          }}
        >
          {pagedJobs?.map((job: any, i: number) => (
            <JobCard
              key={i}
              job={job}
              dronerTenders={dronerTenders}
              offerDeadlineText={offerDeadlineText}
            />
          ))}
        </Box>
      </Container>

      <Stack spacing={2} className="mx-auto">
        <Pagination
          count={Math.ceil(jobsCount / 20)}
          page={page}
          size="large"
          onChange={handlePageChange}
        />
      </Stack>
    </>
  );
};

export default JobsSearch;
